import { render, staticRenderFns } from "./childInformationProtection.vue?vue&type=template&id=1f0b4a10&scoped=true&"
import script from "./childInformationProtection.vue?vue&type=script&lang=js&"
export * from "./childInformationProtection.vue?vue&type=script&lang=js&"
import style0 from "./childInformationProtection.vue?vue&type=style&index=0&id=1f0b4a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b4a10",
  null
  
)

export default component.exports